import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import { connectModal, hide } from 'redux-modal';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Switch from 'react-switch';
import { map, filter, reduce } from 'lodash';
import { Button } from '../utils/forms/Button';
import { Submit } from '../Formik/Submit';
import SelectField from '../Formik/SelectField';
import { getSpotsByLot, editSpot } from '../../actions/parkingSpotActions';
import { setAdminInputValue } from '../../actions/adminActions';
import catchError from '../../utils/catchError';

function PermanentParkingModal({ userId }) {
  const dispatch = useDispatch();
  const [branchId, setBranchId] = useState(null);
  const [floorNr, setFloorNr] = useState(null);
  const [selectResetValue, updateSelectResetValue] = useState(false);

  const remainderEmail = useSelector((state) => state.admin.email_on.value);
  const remainderEmailValue = remainderEmail == 'true';
  const handleCancel = () => {
    dispatch(hide('userPermanentParkingLotModal'));
  };

  const lots = useSelector((state) =>
    map(state.lots, (lot) => ({ label: lot.name, value: lot.id }))
  );
  let spots = useSelector((state) => state.spots);

  spots = filter(spots, (spot) => spot.parkingLotId === branchId);
  spots = filter(spots, (spot) => spot.floor === floorNr);

  const mappedSpots = map(spots, (spot) => ({
    label: spot.place,
    value: spot.placeId
  }));

  const floorSet = new Set(useSelector((state) => map(state.spots, 'floor')));
  const floors = map([...floorSet], (floorNumber) => ({
    label: floorNumber,
    value: floorNumber
  }));

  const initialValues = {
    lot: '',
    floor: '',
    spot: ''
  };

  const valueChanged = (name, value) => {
    if (name === 'lot') {
      setBranchId(value);
      dispatch(getSpotsByLot(value));
    }
    if (name === 'floor') {
      setFloorNr(value);
      updateSelectResetValue(true);
    }
    if (name === 'spot') {
      updateSelectResetValue(false);
    }
  };

  const handleSubmit = (values, { resetForm }) => {
    const { spot } = values;
    const { place } = reduce(spots);
    const data = {
      ...values,
      ...{
        owner: userId,
        id: spot,
        place: place
      }
    };
    dispatch(editSpot(data))
      .then(() => {
        dispatch(hide('userPermanentParkingLotModal'));
      })
      .catch((err) => {
        catchError(err);
      });
  };

  return (
    <div className="modal">
      <div className="modal__container">
        <div className="modal__body">
          <Formik initialValues={initialValues} onSubmit={handleSubmit}>
            <Form>
              <SelectField
                name="lot"
                label="Vyberte parkoviště"
                options={lots}
                onChangeValue={(name, value) => {
                  valueChanged(name, value);
                }}
              />
              <SelectField
                name="floor"
                label="Vyberte patro"
                options={floors}
                onChangeValue={(name, value) => {
                  valueChanged(name, value);
                }}
              />
              <SelectField
                name="spot"
                label="Vyberte parkovací místo"
                options={mappedSpots}
                reset={selectResetValue}
                onChangeValue={(name, value) => {
                  valueChanged(name, value);
                }}
              />
              <div className="general-settings__switch">
                <span>Povolit emailové notifikace</span>
                <Switch
                  name="email_on"
                  height={20}
                  checked={remainderEmailValue}
                  onChange={(value) =>
                    dispatch(setAdminInputValue('email_on', value))
                  }
                />
              </div>
              <div className="center mt2 mxn1">
                <span className="mr1">
                  <Button
                    type="button"
                    color="secondary"
                    onClick={handleCancel}
                  >
                    Zrušit
                  </Button>
                </span>
                <span className="ml1">
                  <Submit value={'Odeslat'} />
                </span>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
    </div>
  );
}

PermanentParkingModal.propTypes = {
  initialValues: PropTypes.shape({
    branch: PropTypes.string,
    floor: PropTypes.string,
    place: PropTypes.string
  })
};

PermanentParkingModal.defaultProps = {
  initialValues: {
    branch: '',
    floor: '',
    place: ''
  }
};

export default connectModal({ name: 'userPermanentParkingLotModal' })(
  PermanentParkingModal
);
